<app-topnav [pageName]="pageName"></app-topnav>
<div class="container">
  <div class="content user-mgmt-page" role="main">
    <header class="user-mgmt-page__header">
      <div>
        <h1 class="user-mgmt-page__title">Role Training</h1>
        <p class="user-mgmt-page__subtitle">Assign one or more onboarding videos (link or upload) to each role. Mandatory courses must be completed before using the portal; optional courses can be skipped.</p>
      </div>
      <div class="user-mgmt-page__actions">
        @if (showAddButton) {
          <a routerLink="/create-role-training" class="user-mgmt-page__btn user-mgmt-page__btn--primary">
            <mat-icon>add</mat-icon>
            Add Training
          </a>
        }
      </div>
    </header>

    <section class="user-mgmt-page__table-card">
      <app-no-results #noResults></app-no-results>

      <table mat-table class="fileList primary" [dataSource]="roles" [hidden]="roles.length === 0">
        <ng-container matColumnDef="Role">
          <th mat-header-cell *matHeaderCellDef>Role</th>
          <td mat-cell *matCellDef="let role">
            <a [routerLink]="['/view-role-training', role.firstCourseId]" class="user-mgmt-page__user-link">{{ role.roleName }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="Title">
          <th mat-header-cell *matHeaderCellDef>Courses</th>
          <td mat-cell *matCellDef="let role">
            {{ role.courseCount === 1 ? role.titles : role.courseCount + ' courses' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Requirement">
          <th mat-header-cell *matHeaderCellDef>Requirement</th>
          <td mat-cell *matCellDef="let role">{{ role.requirement }}</td>
        </ng-container>

        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef>
            Status
            <app-information-popup [information]="information"></app-information-popup>
          </th>
          <td mat-cell *matCellDef="let role">
            <app-status-bubble [status]="role.status"></app-status-bubble>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
      </table>
    </section>
  </div>
</div>
<app-footer></app-footer>
